import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import firebase from 'firebase/compat/app';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApplicationUserService } from './applicationuser.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  errormsg: any;

  constructor(    private notifierService: NotifierService,
    public afAuth: AngularFireAuth,
    private spinner: NgxSpinnerService,
    private userService: ApplicationUserService

    ) { }
    async loginWithPassword(username: string, password: string) {
      this.spinner.show();

      try {
        username = username.replace(/ /g, '');
        const userName = username;
        username= username+'@add-sds-email.com';
        await this.afAuth.signInWithEmailAndPassword(username, password);
        // Login was successful
        this.storeLoginInfo();

        return true;
      } catch (error:any) {
        this.errormsg = error.message;
        console.log("error: " + this.errormsg);
        this.notifierService.notify('error', 'Enter a valid username and password');
        return false;
      } finally {
        // Code in the finally block will execute whether the try block succeeds or not.
        // You can use it to perform cleanup or any necessary actions.
        this.spinner.hide();
      }
    }
    
    doLogout() {
      return new Promise<void>((resolve, reject) => {
        if (firebase.auth().currentUser) {
          this.afAuth.signOut()
          resolve();
        }
        else {
          reject();
        }
      });
    }
    getCurrentUser() {
      return new Promise<any>((resolve, reject) => {
        this.afAuth.onAuthStateChanged(user => {
          if (user) {
            resolve(user);
          } else {
            reject('No user logged in');
          }
        });
      });
    }

    getCurrentUserDetails(userName: string){
    this.spinner.show();
    this.userService.getuserDetails(userName).subscribe((response: any) => {
      this.userService.currentUserDetails = response; // Populate the data array with the API response
      this.spinner.hide();
    });  
    }
    storeLoginInfo(){
      this.userService.saveLoginInfo().subscribe(
        (data) => 
        {if(data)
        console.log(data)
      }
      );
    }
}
